import React, { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { PendenciaDocsProvider } from "./PendenciaDocs";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Bolinha de pendência (owner C1014323): mesmo doc do aviso da aba Geral do /perfil.
  const { user } = useAuth();
  const partnerCnpj = user?.partner_cnpj;
  const resolveDoc = useCallback(() => Promise.resolve(partnerCnpj), [partnerCnpj]);
  return (
    <PendenciaDocsProvider resolveDoc={resolveDoc}>
      <div className="min-h-screen bg-[var(--zemo-bg)] flex">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="flex-1 flex flex-col min-w-0">
          <Header onOpenSidebar={() => setSidebarOpen(true)} />
          <main className="flex-1 px-4 lg:px-8 py-6 lg:py-8 max-w-[1600px] w-full mx-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </PendenciaDocsProvider>
  );
}
